<template>
    <section class="py-16">
        <div class="w-full">

            <h2 class="text-2xl font-bold text-center mb-12">
                {{ __('home::index.inspiration_from_our_customers') }}
            </h2>

            <Swiper
                :modules="modules"
                :loop="true"
                :allowTouchMove="true"
                :space-between="12"
                :breakpoints="{
                    1024: {
                        slidesPerView: 5,
                    },
                    768: {
                        slidesPerView: 4,
                    },
                    320: {
                        slidesPerView: 2,
                    },
                }"
                :slides-offset-after="0"
                :preload-images="false"
                :free-mode="{
                    enabled: true,
                }"
                :speed="7000"
                :autoplay="{
                    delay: 0
                }"
                :lazy="{
                    loadPrevNext: true,
                }"
                class="relative swiper-linear"
            >
                <!-- Slides -->
                <template
                    v-for="(medium, index) in media"
                    :key="index"
                >
                    <SwiperSlide>
                        <div
                            class="relative w-full h-full aspect-w-1 aspect-h-1 rounded-lg shadow-sm overflow-hidden"
                        >
                            <img
                                src=""
                                :data-src="medium"
                                class="swiper-lazy w-full h-full object-cover object-center"
                                :alt="index"
                            />
                            <div
                                class="swiper-lazy-preloader absolute bg-gray-100 w-full h-full flex justify-center items-center"
                            >
                                <PhotographIcon class="w-24 h-24 text-gray-300 animate-pulse" />
                            </div>
                        </div>
                    </SwiperSlide>
                </template>
            </Swiper>
        </div>
    </section>
</template>

<script>
import { Lazy, FreeMode, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import {ChevronLeftIcon, ChevronRightIcon, PhotographIcon} from "@heroicons/vue/outline";

export default {
    components: {
        Swiper,
        SwiperSlide,
        PhotographIcon,
        ChevronLeftIcon,
        ChevronRightIcon,
    },
    data() {
        return {
            modules: [Lazy, FreeMode, Autoplay],
            media: [
                '/media/slider/slide10.jpg',
                '/media/slider/slide8.jpg',
                '/media/slider/slide9.jpg',
                '/media/slider/slide11.jpg',
                '/media/slider/slide12.jpg',
                '/media/slider/slide1.jpg',
                '/media/slider/slide2.jpg',
                '/media/slider/slide3.jpg',
                '/media/slider/slide4.jpg',
                '/media/slider/slide5.jpg',
                '/media/slider/slide6.jpg',
                '/media/slider/slide7.jpg',
            ],
        };
    },
}
</script>
